import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 *
 * Handles the redirect from https://auth.emergentagent.com/. The URL fragment
 * contains `#session_id=...`. We exchange it server-side and set our cookie.
 */
const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) {
      navigate("/login");
      return;
    }

    (async () => {
      try {
        const { data } = await axios.post(
          `${API}/auth/google/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        setUser(data);
        // If Google user has no shipping address on file, collect it before continuing.
        const hasAddress = data?.address && data.address.line1 && data.address.city;
        const fromCart = typeof window !== "undefined" && sessionStorage.getItem("wiu_reopen_cart") === "1";
        let dest = "/account";
        if (!hasAddress) {
          dest = fromCart ? "/complete-profile?next=cart" : "/complete-profile";
        } else if (fromCart) {
          dest = "/";
        }
        window.history.replaceState({}, document.title, dest);
        navigate(dest, { state: { user: data }, replace: true });
      } catch (_e) {
        navigate("/login?err=google");
      }
    })();
  }, [navigate, setUser]);

  return (
    <main className="min-h-screen bg-charcoal flex items-center justify-center" data-testid="auth-callback">
      <div className="flex items-center gap-3 text-off-white/60">
        <Loader2 size={20} className="animate-spin text-rose" />
        <span className="font-mono text-[11px] tracking-[0.25em]">FINALISING SIGN IN…</span>
      </div>
    </main>
  );
};

export default AuthCallback;
